module.exports = __webpack_public_path__ + "assets/img/th-13deec99.png";